import { render, staticRenderFns } from "./Awa.vue?vue&type=template&id=7cd07ea1"
import script from "./Awa.vue?vue&type=script&lang=js"
export * from "./Awa.vue?vue&type=script&lang=js"
import style0 from "./Awa.vue?vue&type=style&index=0&id=7cd07ea1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports